// src/components/MobileHeader/MobileHeader.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logoMamute from "../../assets/logo_mamute.png";
import "./MobileHeader.css";

function MobileHeader({
  onToggleSidebar,
  titulo = "Usuários",
  isKiosk = false,
  logoUrl = null,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const showKioskPlus =
    isKiosk && String(location?.pathname || "").startsWith("/gerenciar/opcoes");

  const handleKioskPlus = () => {
    navigate("/ordens-servico/abrir-nova-os");
  };

  const logo = logoUrl || logoMamute;

  return (
    <header className={`m-header${isKiosk ? " kiosk" : ""}`}>
      {/* Botão Hamburguer (some no Kiosk) */}
      {!isKiosk && (
        <button
          className="m-hamburger"
          aria-label="Menu"
          onClick={onToggleSidebar}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      )}

      {/* Conteúdo do topo */}
      <div className={`m-header-top${isKiosk ? " kiosk-top" : ""}`}>
        {/* LOGO / MARCA */}
        {isKiosk ? (
          <div className="m-kiosk-brand">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt="Logo"
                className="m-kiosk-logo-img"
              />
            ) : (
              <div className="m-kiosk-logo-placeholder" aria-label="Espaço do logo">
                <div className="m-kiosk-logo-title">Coloque seu logo aqui</div>
                <div className="m-kiosk-logo-size">240×64 px</div>
              </div>
            )}
          </div>
        ) : (
          <div className="m-logo-box">
            <img src={logo} alt="Mamute" className="m-logo-img" />
          </div>
        )}

        {/* Títulos (não aparece no Kiosk para ficar “limpo”) */}
        {!isKiosk && (
          <div className="m-title">
            <span className="m-title-main" title={titulo}>
              {titulo}
            </span>
          </div>
        )}

        {/* Botão + (aparece no Kiosk quando estiver em Opções/Aparência) */}
        {isKiosk && showKioskPlus && (
          <button
            type="button"
            className="m-kiosk-plus-btn"
            onClick={handleKioskPlus}
            aria-label="Voltar para abrir OS"
            title="Voltar para abrir OS"
          >
            +
          </button>
        )}

        <div style={{ marginLeft: "auto" }}></div>
      </div>
    </header>
  );
}

export default MobileHeader;
